var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("headers.goodbye")) + "\n      ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "custom-container" }, [
      _c("div", { staticClass: "content text-center" }, [
        _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.$t("headers.goodbye_message")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.primaryResultText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center mt-2" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.secondaryResultText))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }